export const agreementNotice = {
    'zhCN': {
        agreementNotice: {
            syncName: '同步记录名称',
            productPriceChangeNotice: '变更通知',
            retailDiscountNotice: '零售折扣通知',
            distributionAgreement: '经销协议',
            distributionSupplementaryAgreement: '经销补充协议',
            retailCooperationAgreement: '零售合作协议',
            retailSupplementaryAgreement: '零售合作补充协议',
            notDistinguish: '无法识别文件',
            totalFiles: '文件总数',
            signatureCompleted: '签章数量',
            agreementRecordStatus: '状态',
            releaseDate: '发布时间',
            isSendMail: '是否发送邮件',
            syncDate: '同步时间',
            syncFile: '同步文件',
            syncing: '文件同步中，稍后页面查看',
            batchSignatureMessage: '文件签章中，稍后页面查看',
            agreementNoticeDetail: '通知协议明细查询',
            syncFileName: '同步文件名称',
            agreementStartDate: '协议生效日期',
            agreementEndDate: '协议失效日期',
            fileType: '文件类型',
            signatureStatus: '签章状态',
            merckSignatureDate: '默克签章时间',
            snoSyncTime: 'SNO同步时间',
            snoSyncStatus: 'SNO同步状态',
            snoSyncMessage: '同步失败原因',
            upload: '上传',
            chooseShipper: '请选择货主',
            signature: '签章',
            batchSignature: '批量签章',
            sendMail: '发送邮件',
            resendMail: '重发邮件',
            downloadAgreement: '下载协议',
            repushAgreement: '重新推送协议',
            repushAgreementSuccess: '重新推送成功',
            release: '发布',
            releaseSuccess: '发布成功',
            mailSuccess: '发送成功',
            syncSignatureFile: '同步签章文件',
            syncSuccess: '同步成功',
            releaseConfirm: '如需保留单方签章的协议文件，请先同步文件后，再发布；如已同步，忽略此提醒，是否确认发布。'
        }
    },
    'enUS': {
        agreementNotice: {
            syncName: 'Sync Name',
            productPriceChangeNotice: 'ChangeNotice',
            retailDiscountNotice: 'RetailDiscountNotice',
            distributionAgreement: 'DistributionAgreement',
            distributionSupplementaryAgreement: 'DistributionSupplementaryAgreement',
            retailCooperationAgreement: 'RetailCooperationAgreement',
            retailSupplementaryAgreement: 'RetailSupplementaryAgreement',
            notDistinguish: 'NotDistinguish',
            totalFiles: 'TotalFiles',
            signatureCompleted: 'SignatureCompleted',
            agreementRecordStatus: 'AgreementRecordStatus',
            releaseDate: 'ReleaseDate',
            isSendMail: 'IsSendMail',
            syncDate: 'SyncDate',
            syncFile: 'Sync File',
            syncing: 'File synchronization, see later page',
            batchSignatureMessage: 'File signature, see later page',
            agreementNoticeDetail: 'Agreement Notice Detail List',
            syncFileName: 'SyncFileName',
            agreementStartDate: 'AgreementStartDate',
            agreementEndDate: 'AgreementEndDate',
            fileType: 'FileType',
            signatureStatus: 'SignatureStatus',
            merckSignatureDate: 'MerckSignatureDate',
            snoSyncTime: 'SNOSyncTime',
            snoSyncStatus: 'SNOSyncStatus',
            snoSyncMessage: 'SyncFailureMessage',
            upload: 'Upload',
            chooseShipper: 'Choose Shipper',
            signature: 'Signature',
            batchSignature: 'BatchSignature',
            sendMail: 'SendMail',
            resendMail: 'ResendMail',
            downloadAgreement: 'Download',
            repushAgreement: 'Repush',
            repushAgreementSuccess: 'Success',
            release: 'Release',
            releaseSuccess: 'Release Success',
            mailSuccess: 'Mail Success',
            syncSignatureFile: 'Sync Signature File',
            syncSuccess: 'Sync Success',
            releaseConfirm: 'If you want to keep the agreement file signed and sealed by one party, please synchronize the file before publishing. Are you sure to publish it.'
        }

    }
}
export default agreementNotice



// WEBPACK FOOTER //
// ./src/locale/modules/agreementNotice.js